import { createAction } from "typesafe-actions";
import { domain } from "./types.js";
const downloadAction = "/download";
const fileActions = {
  download: createAction(`${domain}${downloadAction}`)()
};
export {
  fileActions
};
//# sourceMappingURL=actions.js.map
